import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

const ChildCategory = (props) => {
  const [isLink2Visible,] = useState(props.showLink2);
  const navigate = useNavigate()
  const [showTooltip, setShowTooltip] = useState(false)

  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(); // Call the onClick function if it exists
    }
    // if (props.Link) {
    //   navigate(props.Link); // Navigate to the URL provided in props.Link
    // }
    if (props.Link) {
      if (event.ctrlKey || event.metaKey) {
        window.open(props.Link, '_blank', 'noopener,noreferrer');
      } else {
        navigate(props.Link);
      }
    }

    event.preventDefault(); // prevent default behavior
  };

  const handleClick2 = (event) => {
    if (props.handleLink2Click) {
      props.handleLink2Click();
    }
    if (props.Link2) {
      if (event.ctrlKey || event.metaKey) {
        window.open(props.Link2, '_blank', 'noopener,noreferrer');
      } else {
        navigate(props.Link2);
      }
    }

    event.preventDefault(); // prevent default behavior
  };


  return (
    <>
      <div className="yes-bm-child-category-box ">
        <i className="fa-solid fa-caret-right floting-arrow"></i>
        <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', margin: '0px', width: '220px', height: '35px', textAlign: 'center' }} onClick={handleClick}>
          {/* <p
            title="Ctrl+Click to open in a new tab"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              margin: '0px',
              width: '220px',
              height: '35px',

              textAlign: 'center',
              cursor: 'pointer',
              transition: 'color 0.1s',
            }}


          >
            {props.heading}
          </p> */}


          <div style={{ position: 'relative', display: 'inline-block',  }}>
            <p className='heading-tooltip'
             
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              {props.heading}
            </p>

            { showTooltip && (
              <div className='custom-tooltip'
          
              >
                Ctrl+Click to open in a new tab
              </div>

            )}
          </div>

        </p>
        {isLink2Visible && (
          <Link to={props.Link2} onClick={handleClick2} className="fixed-arrow">
            <i className="fa-solid fa-plus"></i>
          </Link>
        )}

      </div>


    </>
  )
}

export default ChildCategory